import { useEffect, useState } from "react";
import { Text, useDisclosure } from "@chakra-ui/react";

import { dynamicConfig, localRoutes } from "../../config";
import { getAppVersion } from "../api/helpers/apiFunctions/user";
import { getFromLocalStorage, LocalStorageKeys, setToLocalStorage } from "../utils/localStorage";
import { Dialog } from "./Dialog";
import { messages } from "../locale";

let timeout: NodeJS.Timeout;

export const AppVersionProcess = () => {
  const [showTheDialog, setShowTheDialog] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();

  useEffect(() => {
    const compareProcess = async () => {
      const currentAppVersion = getFromLocalStorage(LocalStorageKeys.currentAppVersion);
      const newAppVersion = await getAppVersion();
      setToLocalStorage(LocalStorageKeys.newAppVersion, newAppVersion);

      if (!currentAppVersion) {
        setToLocalStorage(LocalStorageKeys.currentAppVersion, newAppVersion);
      } else if (currentAppVersion !== newAppVersion) {
        setShowTheDialog(true);
      }
    };

    compareProcess();

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  const handleRefresh = () => {
    setToLocalStorage(LocalStorageKeys.currentAppVersion, getFromLocalStorage(LocalStorageKeys.newAppVersion));
    window.location.reload();
  };

  useEffect(() => {
    if (showTheDialog) {
      const { newVersionDialogTimeout } = dynamicConfig;
      timeout = setTimeout(() => {
        if (window.location.pathname !== localRoutes.videoCall) {
          handleRefresh();
        } else {
          onOpen();
        }
      }, newVersionDialogTimeout * 60 * 1000);
    }

    return () => {
      clearTimeout(timeout);
    };
  }, [showTheDialog]); // eslint-disable-line react-hooks/exhaustive-deps

  const { title, description, buttonConfirm, buttonCancel } = messages.newVersionDialog;

  return (
    <Dialog
      id="new-version-dialog"
      isOpen={isOpen}
      closeOnOverlayClick={false}
      onClose={onClose}
      onConfirm={handleRefresh}
      title={title}
      confirmText={buttonConfirm}
      cancelText={buttonCancel}
    >
      <Text>{description}</Text>
    </Dialog>
  );
};
